// Libraries
import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

// Components
import TopBar from './TopBar';
import Splash from './Splash';
import Dma from './Dma';

// Services and contexts
import { AlertProvider } from '../contexts/AlertContext';
import { LanguageProvider } from '../contexts/LanguageContext';
import { UserProvider } from '../contexts/UserContext';

//Material-UI
import { ThemeProvider } from '@material-ui/styles';
import { createMuiTheme } from '@material-ui/core/styles';
import { blue, red } from '@material-ui/core/colors';

const intelliSenseTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#05539f'
    },
    info: {
      main: '#05539f'
    },
    error: {
      main: red[700]
    }
  }
});

export default function App() {
  return (
    <ThemeProvider theme={intelliSenseTheme}>
      <AlertProvider>
        <LanguageProvider>
          <UserProvider>
            <BrowserRouter>
              <TopBar />
              <Switch>
                <Route exact path="/" component={Splash} />
                <Route exact path="/dma" component={Dma} />
                <Route path="*">
                  <Redirect to="/"></Redirect>
                </Route>
              </Switch>
            </BrowserRouter>
          </UserProvider>
        </LanguageProvider>
      </AlertProvider>
    </ThemeProvider>
  );
}
